<template>
    <div class="cabinet-content-inner">

        <div class="cabinet-notice-big subscribe-text-success">
            <div class="icon"><SuccessIcon/></div>
            <div class="text">Подписка на письмо успешно оформлена!</div>
        </div>
    </div>
</template>

<script>
    import SuccessIcon from "../icons/SuccessIcon";

    export default {
        name: "SubscriptionSuccess",
        components: {SuccessIcon},
        created() {

        }
    }
</script>

<style scoped>

</style>